import {collection} from "@fedeltapointofsale/data-client";
import {ReportData} from "../../../reports/report.data";
import {SellableReportSelectionData} from "../../../catalogue/sellable/controls/sellable-report-selection-control.component";

export class SchedulePromotionReportData extends ReportData<SchedulePromotionReportData> {
    @collection() groupBy: string[] = ["none"];
    @collection(SellableReportSelectionData) sellables: SellableReportSelectionData[];
}
